import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { id: "PatientInfo__Main" }
const _hoisted_2 = { class: "header-row align-items-center fw-bold" }
const _hoisted_3 = { class: "header-cell fw-bold user-name font-size-xl me-2" }
const _hoisted_4 = { class: "header-cell fw-bold mt-sm-1 user-mrn" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "mb-0 mr-1" }, "MRN:", -1 /* HOISTED */)
const _hoisted_6 = { class: "header-row fw-bold font-size-xs" }
const _hoisted_7 = { class: "header-cell" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 1,
  class: "text-default"
}
const _hoisted_10 = { class: "header-cell" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-circle header-divider" }, null, -1 /* HOISTED */)
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 1,
  class: "text-default"
}
const _hoisted_14 = {
  key: 0,
  class: "header-cell"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-circle header-divider" }, null, -1 /* HOISTED */)
const _hoisted_16 = /*#__PURE__*/_createTextVNode()
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "badge CodeStatus__Red" }, "DNR", -1 /* HOISTED */)
const _hoisted_18 = [
  _hoisted_15,
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = { class: "header-row font-size-xs" }
const _hoisted_20 = { class: "information-column d-flex flex-column me-4" }
const _hoisted_21 = { class: "information-cell" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("b", { class: "title" }, "Physician", -1 /* HOISTED */)
const _hoisted_23 = { class: "information-cell" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("b", { class: "title" }, "Phone", -1 /* HOISTED */)
const _hoisted_25 = { class: "information-column d-flex flex-column me-4" }
const _hoisted_26 = { class: "information-cell" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("b", { class: "title" }, "DOB", -1 /* HOISTED */)
const _hoisted_28 = { class: "information-cell" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("b", { class: "title" }, "Phone Type", -1 /* HOISTED */)
const _hoisted_30 = { class: "information-column d-flex flex-column me-4" }
const _hoisted_31 = { class: "information-cell" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("b", { class: "title" }, "SOC", -1 /* HOISTED */)
const _hoisted_33 = { class: "information-cell" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("b", { class: "title" }, "Medical", -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmptyTextHandler = _resolveComponent("EmptyTextHandler")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, [
        _createElementVNode("a", {
          href: "javascript:void(0);",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handlePatientNameClick()))
        }, _toDisplayString(_ctx.selectedPatientDetails.lastName) + ", " + _toDisplayString(_ctx.selectedPatientDetails.firstName), 1 /* TEXT */)
      ]),
      _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("span", null, _toDisplayString(_ctx.selectedPatientDetails.patientIdNumber), 1 /* TEXT */)
      ])), [
        [_directive_tooltip, { title: 'Medical Record Number (MRN)' }]
      ])
    ]),
    _createElementVNode("section", _hoisted_6, [
      _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_7, [
        (_ctx.selectedPatientDetails.gender)
          ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.selectedPatientDetails.gender), 1 /* TEXT */))
          : (_openBlock(), _createElementBlock("span", _hoisted_9, "No Gender Selected"))
      ])), [
        [_directive_tooltip, { title: 'Sex' }]
      ]),
      _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_10, [
        _hoisted_11,
        (_ctx.age)
          ? (_openBlock(), _createElementBlock("span", _hoisted_12, " Age- " + _toDisplayString(_ctx.age), 1 /* TEXT */))
          : (_openBlock(), _createElementBlock("span", _hoisted_13, "No Age added"))
      ])), [
        [_directive_tooltip, { title: 'Age' }]
      ]),
      (_ctx.selectedPatientDetails.isDNR)
        ? (_openBlock(), _createElementBlock("span", _hoisted_14, _hoisted_18))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("section", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("section", _hoisted_21, [
          _hoisted_22,
          _createElementVNode("div", null, [
            _createVNode(_component_EmptyTextHandler, {
              text: _ctx.selectedPatientDetails.physicianName
            }, null, 8 /* PROPS */, ["text"])
          ])
        ]),
        _createElementVNode("section", _hoisted_23, [
          _hoisted_24,
          _createElementVNode("div", null, [
            _createVNode(_component_EmptyTextHandler, {
              text: _ctx.selectedPatientDetails.primaryPhone
            }, null, 8 /* PROPS */, ["text"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("section", _hoisted_26, [
          _hoisted_27,
          _createElementVNode("div", null, [
            _createVNode(_component_EmptyTextHandler, {
              text: _ctx.moment(_ctx.selectedPatientDetails.dob).format('MM/DD/YYYY')
            }, null, 8 /* PROPS */, ["text"])
          ])
        ]),
        _createElementVNode("section", _hoisted_28, [
          _hoisted_29,
          _createElementVNode("div", null, [
            _createVNode(_component_EmptyTextHandler, {
              text: _ctx.selectedPatientDetails.phoneType
            }, null, 8 /* PROPS */, ["text"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("section", _hoisted_31, [
          _hoisted_32,
          _createElementVNode("div", null, [
            _createVNode(_component_EmptyTextHandler, {
              text: _ctx.moment(_ctx.selectedPatientDetails.startofCareDate).format('MM/DD/YYYY')
            }, null, 8 /* PROPS */, ["text"])
          ])
        ]),
        _createElementVNode("section", _hoisted_33, [
          _hoisted_34,
          _createElementVNode("div", null, _toDisplayString(_ctx.selectedPatientDetails.isNonMedical ? "No" : "Yes"), 1 /* TEXT */)
        ])
      ])
    ])
  ]))
}